import {gql} from 'apollo-angular';

export const gql_listaconfig = gql`
query{
    listaConfig{
        idconf
        refrigerio
        descafp
        desciva
        frontera
        minnacional
        tipocambio
  }
}`;

export const gql_actualizaConfig = gql`
mutation($datos:ConfigIn){
    actualizaConfig(input:$datos)
}`;